import styled from 'styled-components';

export const CalendarEditSC = styled.div`
  position: relative;
  padding-bottom: 85px;
`;
